var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"articles",staticStyle:{"background-image":"url('./images/back.svg')"}},[(_vm.articles.length)?_c('article-grid',{attrs:{"articles":_vm.articles}}):_c('base-icon',{staticClass:"icon",attrs:{"name":_vm.$vuetify.breakpoint.width > 800 ? 'statya' : 'statyatablet'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }